<template>
  <div class="list-card" @click="openDetail">
    <div class="list-card__time">{{ showTime }}</div>
    <div aria-hidden="true" class="list-card__dash"></div>
    <div class="list-card__content">
      <el-tooltip :content="planCard.title" effect="dark" placement="top">
        <div class="list-card__title">{{ planCard.title }}</div>
      </el-tooltip>
      <div class="list-card__row">
        <span class="list-card__label">拜访目的</span>
        <el-tooltip :content="planCard.communicateTarget" effect="dark" placement="top">
          <span class="list-card__value">{{ planCard.communicateTarget }}</span>
        </el-tooltip>
      </div>
      <div class="list-card__row list-card__row--meta">
        <div class="list-card__field">
          <span class="list-card__label">执行人</span>
          <el-tooltip
            :content="executeNameList.join('、')"
            effect="dark"
            placement="top"
            popper-class="plan-list-card__execute-tooltip"
          >
            <span v-if="executeNameList.length" class="list-card__value">{{
              showExecuteNameList
            }}</span>
          </el-tooltip>
        </div>
        <div class="list-card__field">
          <span class="list-card__label">创建人</span>
          <el-tooltip :content="planCard.creatorName" effect="dark" placement="top">
            <span class="list-card__value">{{ planCard.creatorName }}</span>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import xbb from '@xbb/xbb-utils'
import xbbSdk from 'xbb-sdk'
import { getCustomRecordInfo } from '@/api'

const props = defineProps({
  planCard: {
    type: Object,
    required: true
  }
})

const showTime = computed(() => {
  if (!props.planCard.executeTime) {
    return ''
  }
  return xbb.formatTime(props.planCard.executeTime, 'HH:mm')
})

const executeNameList = computed(() => {
  if (!props.planCard.executeName) {
    return []
  }
  return props.planCard.executeName.split(',').filter((name) => name)
})

const showExecuteNameList = computed(() => {
  if (executeNameList.value.length) {
    return (
      executeNameList.value[0] +
      (executeNameList.value.length > 1 ? ' 等' + executeNameList.value.length + '人' : '')
    )
  } else {
    return ''
  }
})

const openDetail = async () => {
  const res = await getCustomRecordInfo({ businessType: 601 })
  const { appId, businessType, subBusinessType } = res.result

  xbbSdk.sendMessage('openDetailPage', {
    appId: appId,
    dataId: props.planCard.id,
    saasMark: 1,
    businessType: businessType,
    subBusinessType: subBusinessType,
    uuid: xbbSdk.props.uuid
  })
}
</script>

<style lang="scss" scoped>
.list-card {
  --list-card-border: #f2f3f5;
  --list-card-title: #323233;
  --list-card-label: #646566;
  --list-card-value: #323233;
  display: flex;
  align-items: center;
  min-height: 100px;
  border: 1px solid var(--list-card-border);
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 12px;
  cursor: pointer;
  .list-card__time {
    flex: 0 0 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 22px;
    color: var(--list-card-title);
  }
  .list-card__dash {
    flex: 0 0 auto;
    width: 1px;
    height: 68px;
    border-right: 1px dashed var(--list-card-border);
  }
  .list-card__content {
    flex: 1;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    > * + * {
      margin-top: 8px;
    }
    .list-card__title {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: var(--list-card-title);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .list-card__row {
      display: flex;
      align-items: center;
      min-height: 20px;
      overflow: hidden;
      > * + * {
        margin-left: 12px;
      }
      .list-card__label {
        flex: 0 0 auto;
        font-size: 14px;
        line-height: 20px;
        color: var(--list-card-label);
        margin-right: 12px;
      }
      .list-card__value {
        font-size: 14px;
        line-height: 20px;
        color: var(--list-card-value);
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .list-card__row--meta {
      > * + * {
        margin-left: 16px;
      }
      .list-card__field {
        display: flex;
        align-items: center;
        overflow: hidden;
      }
      .list-card__field + .list-card__field {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          left: -14px;
          top: 50%;
          width: 12px;
          height: 1px;
          transform: translateY(-50%);
          background: var(--list-card-border);
        }
      }
    }
  }
}
.list-card:hover {
  background: #f2f3f5;
}
</style>

<style lang="scss">
.plan-list-card__execute-tooltip {
  max-width: 240px;
  white-space: normal;
  word-break: break-all;
}
</style>
